export const MODAL_DEFAULT_WIDTH = '375px';
export const MODAL_DEFAULT_HEIGHT = '362px';
export const MODAL_DEFAULT_PADDING = '40px 40px 20px';
